import { render } from "./AboutView.vue?vue&type=template&id=3e85c2ec&scoped=true&ts=true"
import script from "./AboutView.vue?vue&type=script&lang=ts"
export * from "./AboutView.vue?vue&type=script&lang=ts"

import "./AboutView.vue?vue&type=style&index=0&id=3e85c2ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e85c2ec"]])

export default __exports__